import {Link} from "react-router-dom";

export default function SampleColorCard({name, description=null, colorClass,publicClass ,color=null,click,width='col-md-4 col-xl-2 col-6'}) {
    return (
        <div className={`${width} text-center cursor-pointer `} >

            <div className={`mb-2 card ${colorClass} text-white`}  onClick={click}>
                <div className={color? `card-header ${publicClass}` : `card-header ${colorClass} ${publicClass}`} style={{backgroundColor: `${color}`}}>
                    <span>{name}</span>
                    {description!=null ? (
                        <>
                            <br />
                        <span>{description}</span>
                        </>
                    ) : null}
                </div>

            </div>
        </div>
    )
}

//cursor-pointer -bg-primary  -bg-secondary - bg-success - bg-danger - bg-warning -bg-info